import { errors } from "../../copy/errors";

/** Calm placeholder while Carno is briefly unreachable. Retries happen on their own. */
export function Reconnecting({ fill = false }: { fill?: boolean }) {
  return (
    <div role="status" className={fill ? "flex min-h-dvh items-center justify-center p-6" : "flex size-full items-center justify-center p-6"}>
      <div className="flex max-w-sm flex-col items-center gap-3 text-center">
        <span aria-hidden="true" className="relative flex size-3">
          <span className="absolute inline-flex size-full animate-ping rounded-full bg-primary opacity-60 motion-reduce:animate-none" />
          <span className="relative inline-flex size-3 rounded-full bg-primary" />
        </span>
        <p className="text-base font-semibold">{errors.reconnectingTitle}</p>
        <p className="text-sm text-muted-foreground">{errors.reconnectingBody}</p>
      </div>
    </div>
  );
}
